export default __webpack_public_path__ + "static/media/lieferheld_xl1.3322c443.png";